<template>
    <div class="container">
        <div class="col-md-12">
            <h2> {{ labels.title }} </h2>
        </div>
        <div class="col-md-9 d-flex justify-content-end">
            <md-button style="background-color: #2e507a; width: 35px; height: 35px;" class="md-fab md-primary" @click="createCentroCostos">
                <md-icon>add</md-icon>
            </md-button>
        </div>
        <div class="row justify-content-center mt-3" v-if="listCentroCostos.length > 0">
            <div class="col-md-6">
                <b-table
                    :items="listCentroCostos"
                    :fields="fields"
                    hover
                    bordered
                    responsive
                    sticky-header="500px"
                    small
                    class="tblEstandar"
                    head-variant="custom-blue"
                    :per-page="perPage"
                    :current-page="currentPage"
                    @row-clicked="(item) => editCentroCostos(item.id)"
                >
                    <template #cell(codigo)="data">
                        <div class="text-right">{{ data.item.codigo }}</div>
                    </template>
                    <template #cell(centro_costo)="data">
                        <div class="text-right">{{ data.item.centro_costo }}</div>
                    </template>
                </b-table>
                <div class="row col-md-12 mt-1">
                    <div class="col-md-10 d-flex justify-content-center">
                        <b-pagination
                            v-model="currentPage"
                            :per-page="perPage"
                            :total-rows="listCentroCostos.length"
                            align="center"
                            size="md"
                            class="custom-pagination"
                        ></b-pagination>
                    </div>
                    <div class="col-md-2 d-flex justify-content-end">
                        <label class="mr-2 mb-0">Filas por página:</label>
                        <b-form-select
                            v-model="perPage"
                            :options="[5, 10, 20, 50, 100, 500]"
                            size="sm"
                            style="width: 80px;"
                        ></b-form-select>
                    </div>
                </div>
                <!-- <md-table md-card md-header v-model="listCentroCostos">
                    <md-table-row slot="md-table-row" slot-scope="{ item }" @click="editCentroCostos(item.id)">
                        <md-table-cell :md-label="labels.codigo" class="border text-left">{{ item.codigo }}</md-table-cell>
                        <md-table-cell :md-label="labels.descripcion" class="border text-left">{{ item.descripcion }}</md-table-cell>
                        <md-table-cell :md-label="labels.centro_costo" class="border text-left">{{ item.centro_costo }}</md-table-cell>
                    </md-table-row>
                </md-table> -->
            </div>
        </div>
        <div class="row col-md-12 justify-content-center mt-3" v-else>
            <h5>{{ labels.noRow }}</h5>
        </div>
        <Crear :modCrearCentroCostos="showCentroCostos" @cierraModal="closeModal"/>
        <Editar :modEditarCentroCostos="showEditCentroCostos" :infoCentroCostos="dataCentroCosto" @cierraModal="closeModal"/>
    </div>
</template>

<script>
import CentroCostos from '../../../services/CentroCostos'
import Crear from './Crear.vue';
import Editar from './Editar.vue';
export default {
    name : 'CentroCostos',
    components : {
        Crear,
        Editar
    },
    data : () => ({
        listCentroCostos : [],
        showCentroCostos : false,
        showEditCentroCostos : false,
        dataCentroCosto : [],
        perPage: 10,
        currentPage: 1,
        fields: [
            { key: 'codigo', label: 'Código', sortable: false },
            { key: 'descripcion', label: 'Descripción', sortable: false },
            { key: 'centro_costo', label: 'Centro de costo', sortable: false },
        ],
    }),
    computed : {
        labels(){
            if(this.$store.state._language == "es-ES"){
                return {
                    title : 'Centro de costos',
                    codigo : 'Código',
                    descripcion : 'Descripción',
                    centro_costo : 'Centro de Costo',
                    noRow : 'No hay registros.'
                }
            }else{
                return {
                    title : 'Cost center',
                    codigo : 'Code',
                    descripcion : 'Description',
                    centro_costo : 'Centro de Costo',
                    noRow : 'There are no records.'
                }
            }
        }
    },
    methods:{
        closeModal(val){
           this.showCentroCostos = val 
           this.showEditCentroCostos = val 
        },
        createCentroCostos(){
            this.showCentroCostos = true
        },
        editCentroCostos(id){
            // console.log(id);            
            CentroCostos.getCentroCostosById(id)
            .then((res) => {
                // console.log(res.data);
                this.dataCentroCosto = res.data.centroCosto
                this.showEditCentroCostos = true
            })
            .catch((err) => console.log(err))
        }
    },
    mounted(){
        CentroCostos.getAllCentroCostos()
        .then((res) => {
            this.listCentroCostos = res.data.listCentroCostos
        })
        .catch((err) => (console.log(err)))
    }
}
</script>

<style>

</style>
